import { ApiClientService, RequestConfig } from '@dfl/react-security';
import { IBannerCampaign } from 'modules/campaigns/interfaces';
import { EntityApiService } from 'modules/common/service';
import { ICurrency } from 'modules/common/constants';
import { CAMPAIGN_STATUS_ENUM } from 'modules/campaigns/constants/common/status.enum';

class BannerCampaignService extends EntityApiService<IBannerCampaign | Error> {
  evaluate = (id: string, currency: ICurrency, config?: RequestConfig): Promise<IBannerCampaign> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/${currency}/evaluate`), {}, config));
  };

  updateStatus = (id: string, status: CAMPAIGN_STATUS_ENUM, config?: RequestConfig) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/${status}`), {}, config));
  };
}

export default new BannerCampaignService('/ms-business/api/banner-campaign');
